export default __webpack_public_path__ + "static/ildebote-c1c6b30299051b69d5a88976a8741157.png";